module.exports = __webpack_public_path__ + "img/errors-empty.4167076e.png";